// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageTitleBox_container__f3ZDc {
  display: flex;
}
@media only screen and (max-width: 48rem) {
  .PageTitleBox_container__f3ZDc {
    flex-direction: column;
  }
}

.PageTitleBox_left__cKHDY {
  display: flex;
  gap: 1rem;
  flex: 1 1;
}
.PageTitleBox_left__cKHDY h4 {
  margin: 0px;
  height: 36px;
  display: flex;
  align-items: center;
}

.PageTitleBox_right__y6IvO {
  display: flex;
  justify-content: center;
}

.PageTitleBox_separator__rvDld {
  background-color: #b2b2b2;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/PageTitleBox.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EAHF;IAII,sBAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,SAAA;EACA,SAAA;AAEF;AAAE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAEJ;;AAEA;EACE,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n}\n@media only screen and (max-width: 48rem) {\n  .container {\n    flex-direction: column;\n  }\n}\n\n.left {\n  display: flex;\n  gap: 1rem;\n  flex: 1;\n}\n.left h4 {\n  margin: 0px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n}\n\n.right {\n  display: flex;\n  justify-content: center;\n}\n\n.separator {\n  background-color: #b2b2b2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PageTitleBox_container__f3ZDc`,
	"left": `PageTitleBox_left__cKHDY`,
	"right": `PageTitleBox_right__y6IvO`,
	"separator": `PageTitleBox_separator__rvDld`
};
export default ___CSS_LOADER_EXPORT___;
